import React, { useState } from 'react';

import {
  ButtonLink,
  Dialog,
  DialogContent,
  DialogHeader,
  Flex,
  H3
} from '@lucidhq/lucidium';

import { ROUTES, URLS } from '~/constants';
import { t } from '~/utils/i18n';

type BackToStudiesDialogProps = {
  children?: ({ onToggle }: { onToggle: () => void }) => React.ReactNode;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export const BackToStudiesDialog = ({
  children,
  isOpen,
  onOpenChange
}: BackToStudiesDialogProps) => {
  const isControlled = isOpen !== undefined;

  const [internalOpen, setInternalOpen] = useState(false);

  const handleToggle = () => {
    if (isControlled && onOpenChange) {
      onOpenChange(!isOpen);
    } else {
      setInternalOpen(prev => !prev);
    }
  };

  return (
    <>
      {children && children({ onToggle: handleToggle })}
      <Dialog
        isOpen={isControlled ? isOpen : internalOpen}
        onClose={handleToggle}
        lss={{ width: '43rem' }}
      >
        <DialogHeader palette="primary" onClose={handleToggle}>
          {t('backToStudiesDialog.title')}
        </DialogHeader>
        <DialogContent
          lss={{ minHeight: '8rem', textAlign: 'center', gap: '4rem' }}
        >
          <H3>{t('backToStudiesDialog.description')}</H3>
          <Flex
            lss={{
              flexDirection: 'row',
              gap: '2rem',
              justifyContent: 'center'
            }}
          >
            <ButtonLink
              palette="secondary"
              emphasis="medium"
              to={ROUTES.adminCampaigns}
            >
              {t('backToStudiesDialog.classicView')}
            </ButtonLink>
            <ButtonLink palette="secondary" to={URLS.IM_UI} lss={{ mr: 'sm' }}>
              {t('backToStudiesDialog.newExperience')}
            </ButtonLink>
          </Flex>
        </DialogContent>
      </Dialog>
    </>
  );
};
